import { owaDate } from 'owa-datetime';
// September 1st 4500 (Month starts from 0)
var utcPinnedDate = owaDate('UTC', 4500, 8, 1);
// For sending out the service request, we must use the UTC time when marking the conversation as pinned.
// Drop the 'Z' at the end of the timestamp
// This time is used when sending request to the server to mark items as pinned and we have to send the
// time in EWS format
var utcPinnedEwsTimeStamp = utcPinnedDate.toISOString().slice(0, -1);
/**
 * Gets a boolean which indicates whether a table conversation relation is pinned
 * @param tableConversationRelation which contains the renew time stamp
 * @returns boolean which indicates whether the relation is pinned
 */
export function getIsTableConversationRelationPinned(tableConversationRelation) {
    return getIsPinnedTimestamp(tableConversationRelation.lastDeliveryOrRenewTimeStamp);
}
/**
 * Gets a boolean which indicates whether a table conversation relation is pinned
 * @param item which contains the renew time stamp
 * @returns boolean which indicates whether the item is pinned
 */
export function getIsTableItemDataPinned(item) {
    return getIsPinnedTimestamp(item.ReceivedOrRenewTime);
}
/**
 * Get a boolean which indicates whether a notification row is pinned
 * @param row the row data inside the notification
 * @param listViewType of the table
 * @returns true if the row is pinned, false otherwise
 */
export function getIsMailNotificationRowPinned(row, listViewType) {
    var renewTimestamp;
    switch (listViewType) {
        case 0 /* Conversation */:
            renewTimestamp = row.LastDeliveryOrRenewTime;
            break;
        case 1 /* Message */:
            renewTimestamp = row.ReceivedOrRenewTime;
            break;
    }
    return getIsPinnedTimestamp(renewTimestamp);
}
/**
 * Get if a time stamp is a pinned time stamp
 * @param renewTimestamp
 */
function getIsPinnedTimestamp(renewTimestamp) {
    // When the row has been stamped with the locale pinned time stamp upon user pinning it,
    // we have seen some users who have differnet timezones reporting that its
    // trying to render the return time on the item which means the item/conv was detected as snoozed
    // as per our logic in getMailListItemDataProps.
    // Apart from comparing the renew time with the utc pinned time we need to also compare
    // the renewTimeStamp with the local pinned time stamp as well when deciding whether the item/conv is pinned or not.
    if (renewTimestamp === getLocalPinnedTimeStamp()) {
        return true;
    }
    var renewDate = new Date(renewTimestamp);
    return renewDate.getTime() == utcPinnedDate.getTime();
}
// For updating client upon pinning,
// we need to convert the utc pinned time to local time to compare,
// as server always returns the local time.
function getLocalPinnedTimeStamp() {
    try {
        // If browser does not have the timezone set, toLocaleString will throw error
        // in which case we shall not do instant local update and have it update through notification
        return new Date(utcPinnedDate.getTime()).toLocaleString();
    }
    catch (error) {
        return null;
    }
}
export { utcPinnedEwsTimeStamp, getLocalPinnedTimeStamp };
//# sourceMappingURL=pinningUtils.js.map